import { gql } from '@apollo/client';

export const getLocalidadesCDNI = gql`
query localidadApi{
    localidades(idProvincia:$idProvincia)  
    @rest(type: "Localidades", path: "/BuscadorSucursal/LocalidadesCDNI?idProvincia={args.idProvincia}"){
        id_localidad
        desc_localidad
    }
}
`   